import { render, staticRenderFns } from "./FilesPart.vue?vue&type=template&id=4fe27ba6&"
import script from "./FilesPart.vue?vue&type=script&lang=ts&"
export * from "./FilesPart.vue?vue&type=script&lang=ts&"
import style0 from "./FilesPart.vue?vue&type=style&index=0&id=4fe27ba6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
